import { FC } from 'react';

interface StructuredDataProps {
  schema: object;
}

/**
 * Renders structured data as a JSON-LD script tag with proper hydration handling.
 *
 * This component handles the suppressHydrationWarning internally to avoid
 * hydration mismatches that occur with script type="application/ld+json"
 * in React Router / Remix SSR.
 */
export const StructuredData: FC<StructuredDataProps> = ({ schema }) => {
  return (
    <script
      type="application/ld+json"
      suppressHydrationWarning
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema),
      }}
    />
  );
};
